module.exports = __webpack_public_path__ + "img/tg.00835c0e.svg";